export default "__VITE_ASSET__DI5VgE7T__"